/**
 * Created by DejanK on 1/11/2017.
 *
 * rbMax
 *
 * Validates that number is not greater of given value
 */
export default rbMax;

function rbMax() {
  return {
    require: '?ngModel',
    link: (s, e, attrs, ngModelCtrl)=>{
      const max = parseFloat(attrs.rbMax);
      if(!isNaN(max)){
        if(ngModelCtrl){
          ngModelCtrl.$validators.rbMax = (modelValue, viewValue)=>{
            const v = parseFloat(modelValue || viewValue);
            return isNaN(v) || v <= max;
          }
        }
      } else {
        throw new Error(`RbMax requires a number but got ${attrs.rbMax}`);
      }
    }
  }
}
